import { ChangeEvent, FC, useEffect, useRef, useState } from 'react'
import { uploadImage } from './service'
import { Spin, message, Icon } from 'mk-pc'
import './index.scss'

interface Props {
  value?: string
  max?: number
  onChange?: (e: string) => void
}

export const ImageUpload: FC<Props> = ({ value, max = 500, onChange }: Props) => {
  const imageInput = useRef<HTMLInputElement>(null)
  const [loading, setLoading] = useState(false)
  const [imageSrc, setImageSrc] = useState('')

  useEffect(() => {
    setImageSrc(value || '')
  }, [value])

  /**
   * 点击上传
   */
  const handleUpload = () => {
    if (imageInput.current) {
      imageInput.current.click()
    }
  }

  /**
   * 选择文件
   * @param e
   */
  const onImageChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files![0]
    if (!file) return

    if (file.size / 1024 > max) {
      return message.warning(`文件大小不能大于${max}KB`, 2)
    }

    try {
      setLoading(true)

      const formData = new FormData()
      formData.append('file', file)
      const { fileName } = await uploadImage(formData)

      const imageUrl = 'https://www.kiefer.cn/files/images/' + fileName

      setImageSrc(imageUrl)

      setLoading(false)

      if (onChange) {
        onChange(imageUrl)
      }
    } catch (e) {
      setLoading(false)
    }
  }

  return (
    <>
      <input ref={imageInput} type="file" accept="image/*" style={{ display: 'none' }} onChange={onImageChange} />
      <Spin spinning={loading} delay={300} wrapperClassName="spin-wrap">
        <div className="image-upload" onClick={handleUpload}>
          {imageSrc ? (
            <div className="image-upload__display">
              <img src={imageSrc} />
            </div>
          ) : (
            <div className="image-upload__text">
              <p>
                <Icon name="icon-yunshangchuan_o" size="30" />
              </p>
              <p style={{ marginTop: 10 }}>点击上传图片</p>
              <p className="tip">图片大小限制{max}KB以内</p>
            </div>
          )}
        </div>
      </Spin>
    </>
  )
}
